// extracted by mini-css-extract-plugin
export default {"root":"IconArrow_root__DZdHu","open":"IconArrow_open__vxXBG","stroke":"IconArrow_stroke__yzkwR"};